export enum DonationSource {
  resupply = 'resupply',
  charity = 'charity',
  partner = 'partner',
  territory = 'territory',
}
